import {EstateCardProps, EstateCardViewModeType} from "../../EstateCard/EstateCard";
import {Handle, Position} from "@xyflow/react";
import React from "react";
import {DistributionType} from "../../../model/EstateFlowchartTypes";
import NonTrustDistributionsLayer from "./NonTrustDistributionsLayer";
import NodeBrackets, {NodeBracketsPosition} from "./NodeBrackets";
import TrustDistributionLayer from "./TrustDistributionLayer";
import classNames from "classnames";

export type DistributionsNodeProps = {
    height: number,
    width: number,
    nonTrustDistributions: EstateCardProps[],
    trustDistributions: EstateCardProps[][],
    viewMode: EstateCardViewModeType,
    showBottomBracket?: boolean,
    selectedCardId?: string,
    selectedCardRef?: React.RefObject<HTMLDivElement>
}

const DistributionsNode = ({data}: {data: DistributionsNodeProps}) => {
    const getAllCharityDistributions = (): EstateCardProps[] => {
        return data.nonTrustDistributions.filter(distribution => distribution.estateItem.distributionType === DistributionType.CHARITY);
    };

    const getAllOutrightDistributions = (): EstateCardProps[] => {
        return data.nonTrustDistributions.filter(distribution => distribution.estateItem.distributionType === DistributionType.OUTRIGHT);
    }

    const allNonTrustDistributions = getAllOutrightDistributions().concat(getAllCharityDistributions());

    return <div className={"distributions-node"} style={{width: data.width}}>
        <Handle type={"target"} position={Position.Top}/>

        <div className={classNames(
            "distributions-node-content",
            {"first-death-beneficiaries-level": data.showBottomBracket})}>

            <NodeBrackets nodeBracketPosition={NodeBracketsPosition.TOP}/>
            <div className={`all-distributions-layout ${data.viewMode}-view-grid-gap`}>
                {data.nonTrustDistributions.length > 0 &&
                    <NonTrustDistributionsLayer estateCardProps={allNonTrustDistributions}
                                                viewMode={data.viewMode}
                                                selectedCardRef={data.selectedCardRef}
                                                selectedCardId={data.selectedCardId}
                    />}
                {data.trustDistributions.length > 0 &&
                    <TrustDistributionLayer estateCardProps={data.trustDistributions}
                                            viewMode={data.viewMode}
                                            selectedCardRef={data.selectedCardRef}
                                            selectedCardId={data.selectedCardId}
                    />}
            </div>
            {data.showBottomBracket && <NodeBrackets nodeBracketPosition={NodeBracketsPosition.BOTTOM}/>}

        </div>

        <Handle type={"source"} position={Position.Bottom}/>
    </div>;
}

export default DistributionsNode;